import { render, staticRenderFns } from "./trainee.vue?vue&type=template&id=68a46a6f"
import script from "./trainee.vue?vue&type=script&lang=js"
export * from "./trainee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports